module.exports = __webpack_public_path__ + "static/media/NYU-Logo.9dbfff36.png";